import React, { Component } from 'react';

class FaqPage extends Component {
  render() {
    return (
      <div className="section">
        <div className="section__content">
          <div className="b-row">
            <div className="b-col-12">
              <h2 className="h2-title">Frequently Asked Questions</h2>
              <div className="grey-text text-darken-2">
                <h5>What is InstaLinks?</h5>
                <p>
                  InstaLinks is a service that provides you with a customized
                  landing page and a single, short link that you can use in
                  Instagram and other social media sites. When your followers
                  click the link in your bio, it will take them to your custom
                  InstaLinks Page where they can easily navigate to any online
                  presence you wish to share. Since Instagram only allows a
                  single link in your profile "bio", InstaLinks becomes your
                  lifeline to any other links you want to add.
                </p>

                <h5>How much does InstaLinks cost?</h5>
                <p>InstaLinks is $9.00/month for InstaLinks Pro.</p>

                <p>
                  Save 20% by paying for a yearly subscription at $87.00/year.
                  See Pricing for more information.
                </p>

                <h5>Can I customize my InstaLinks link URL?</h5>
                <p>Yes, you can customize the link.</p>

                <h5>
                  How do I know if anyone is clicking the links in my InstaLinks
                  Page?
                </h5>
                <p>
                  We provide tracking for the number of clicks on your links in
                  the dashboard.
                </p>

                <h5>What if I decide to cancel my subscription?</h5>
                <p>
                  You can cancel at any time and you won't be charged. The
                  cancellation will be effective at the end of the current
                  billing period. We do not offer refunds for unused time in a
                  billing period. But let's be real - InstaLinks Pro is pretty
                  awesome, so it's hard for us to imagine you'd ever need to
                  think about cancelling :)
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default FaqPage;



// WEBPACK FOOTER //
// ./src/components/Faq/Faq.js